import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const TileRadioGrid = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: ${spacing.base};
`;
